// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__DH7d4","grid":"styles_grid__NjZc_","intro":"styles_intro__FbVla"};